import { apiClient } from "./api";

export async function getWeeklyStatus() {
  const { data } = await apiClient.get(`/weekly/status?_=${Date.now()}`);
  return data;
}

export async function submitWeeklySetup({ main_goal_context, identity_anchor }) {
  const { data } = await apiClient.post("/weekly/setup", { main_goal_context, identity_anchor });
  return data;
}

export async function submitWeeklyCheckin({ weekly_window_identifier, rotation_position, answers, question_8 }) {
  const { data } = await apiClient.post("/weekly/submit", { weekly_window_identifier, rotation_position, answers, question_8 });
  return data;
}

export async function getWeeklyInsights(submissionId) {
  const { data } = await apiClient.get(`/weekly/insights/${submissionId}?_=${Date.now()}`);
  return data;
}

export async function submitInsightsSatisfaction(submissionId, { rating, feedback, support_request }) {
  const body = { rating, feedback };
  if (support_request !== undefined) body.support_request = support_request;
  const { data } = await apiClient.post(`/weekly/insights/${submissionId}/satisfaction`, body);
  return data;
}

export async function getWeeklyInsightsHistory() {
  const { data } = await apiClient.get(`/weekly/insights?_=${Date.now()}`);
  return data;
}

export async function getResultsSnapshot() {
  const { data } = await apiClient.get(`/weekly/insights/snapshot?_=${Date.now()}`);
  return data;
}
